<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title13"><h1 class="title">Table of Contents</h1>
</a><div class="toc_entry"><a id="title13"><br/>
</a><span class="toc_entry_titlePage" href="#/e9781439621776_tp01" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781439621776_cop01" title="Link target outside of Sample"><span>Copyright Page</span></span><br/>
<a class="toc_entry_acknowPage" href="#/e9781439621776_ack01"><span>Acknowledgments</span></a><br/>
<a class="toc_entry_frontMatter" href="#/e9781439621776_fm02"><span>A Brief History of Irvington</span></a><br/>
<span class="toc_entry_chapter" href="#/e9781439621776_c01" title="Link target outside of Sample"><span><em class="i">One</em> - Camptown Days</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439621776_c02" title="Link target outside of Sample"><span><em class="i">Two</em> - A Quiet Country Village</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439621776_c03" title="Link target outside of Sample"><span><em class="i">Three</em> - A Population of Good Citizens</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439621776_c04" title="Link target outside of Sample"><span><em class="i">Four</em> - The Spirit of Enterprise</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439621776_c05" title="Link target outside of Sample"><span><em class="i">Five</em> - To Serve the People</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439621776_c06" title="Link target outside of Sample"><span><em class="i">Six</em> - Irvington Comes of Age</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439621776_c07" title="Link target outside of Sample"><span><em class="i">Seven</em> - Kaleidoscopic Years</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439621776_toc01.vue?527e77be